export const CHAIN_ID = {
  Polygon: 137,
  Polygon_Mumbai: 80001,
  ThunderCoreMainnet: 108,
  ThunderCoreTestnet: 18,
};
